import React from "react";
import { Text, View } from "react-native";
import tw from "twrnc";

import HelpTip from "./HelpTip";
import { colors, space, text } from "./theme";

// Page and section headers for settings screens.
//
//   <SettingsPage title="Privacy" help="privacy.access" description="…">
//     <SettingsSection title="Who can watch" help="…">…</SettingsSection>
//     <SettingsSection title="Replay and download">…</SettingsSection>
//   </SettingsPage>
//
// Page title 24px, section titles 18px, descriptions 14px muted. Sections are
// 32px apart; the first one sits 24px under the page header.

export const SettingsPage = ({
  title,
  help,
  description,
  right,
  children,
  style,
}) => (
  <View style={style}>
    {!!title && (
      <View style={{ marginBottom: space.pageHeader }}>
        <View style={tw`flex-row items-center`}>
          <View style={tw`flex-row items-center flex-1 flex-wrap`}>
            <Text accessibilityRole="header" style={text.pageTitle}>
              {title}
            </Text>
            {!!help && <HelpTip topic={help} size={18} style={tw`ml-2`} />}
          </View>
          {right}
        </View>
        {!!description && (
          <Text style={[text.body, { color: colors.muted, marginTop: 6 }]}>
            {description}
          </Text>
        )}
      </View>
    )}
    {children}
  </View>
);

export const SectionTitle = ({ title, help, description, right, style }) => (
  <View style={[{ marginBottom: space.sectionTitleGap }, style]}>
    <View style={tw`flex-row items-center`}>
      <View style={tw`flex-row items-center flex-1`}>
        <Text accessibilityRole="header" style={text.sectionTitle}>
          {title}
        </Text>
        {!!help && <HelpTip topic={help} />}
      </View>
      {right}
    </View>
    {!!description && <Text style={[text.hint, tw`mt-1`]}>{description}</Text>}
  </View>
);

export const SettingsSection = ({
  title,
  help,
  description,
  right,
  first,
  children,
  style,
}) => (
  <View style={[!first && { marginTop: space.section }, style]}>
    {!!title && (
      <SectionTitle
        title={title}
        help={help}
        description={description}
        right={right}
      />
    )}
    {children}
  </View>
);

export const SettingsDivider = ({ style }) => (
  <View
    style={[
      {
        height: 1,
        backgroundColor: colors.divider,
        marginVertical: space.field,
      },
      style,
    ]}
  />
);

export default SettingsPage;
